function initGroupform() {

    let form = document.getElementById('Form_GroupForm');
    if  (form){
        let pageId = form.getAttribute('data-page-id');
        if  (pageId){
            let dropdownHolder = document.getElementById('Form_GroupForm_TourType_Holder');
            if  (dropdownHolder){
                dropdownHolder.style.display = 'none';
            }
        }
    }
}

export default initGroupform;
